import { render } from "./SimpleNoteCreateFooterActions.vue?vue&type=template&id=f8451070"
import script from "./SimpleNoteCreateFooterActions.vue?vue&type=script&lang=js"
export * from "./SimpleNoteCreateFooterActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__